import React, { useCallback } from 'react';
import { getHours } from 'date-fns';
import { useAuthenticatedSession } from '../../../../hooks';
import logo from '../../../../assets/logo.png';
import { LogoutIcon } from '../../../../components/icons';
import { Container } from './styles';

const Header: React.FC = () => {
    const { user, logout } = useAuthenticatedSession();

    const getPeriodDay = useCallback(() => {
        const hours = getHours(new Date());

        if (hours < 6)
            return 'Boa madrugada';

        if (hours < 12)
            return 'Bom dia';

        if (hours < 18)
            return 'Boa tarde';

        return 'Boa noite';
    }, []);

    return (
        <Container>
            <div>
                <img src={logo} alt="Flix Media Ticketx" />
                <LogoutIcon
                    id="home.logoutbutton"
                    onClick={logout}
                />
            </div>
            <div >
                <label>{`${getPeriodDay()},`}</label>
                <label>{user.name}</label>
            </div>
        </Container>
    );
};

export { Header };
